import React, { useEffect, useState } from "react";
import api, { formatErr } from "../../../lib/api";
import { card, label, input, btn, btnGhost, SvgViewer, downloadBlob } from "./_drawingsCommon";

export default function GAPanel({ projectId }) {
  const [views, setViews] = useState([]);
  const [disciplines, setDisciplines] = useState(["All"]);
  const [view, setView] = useState("PLAN");
  const [discipline, setDiscipline] = useState("All");
  const [runId, setRunId] = useState("");
  const [drawingNo, setDrawingNo] = useState("");
  const [revision, setRevision] = useState("0");
  const [blobUrl, setBlobUrl] = useState(null);
  const [filename, setFilename] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/projects/${projectId}/ga/views`)
      .then(({ data }) => { setViews(data.views || []); setDisciplines(data.disciplines || ["All"]); })
      .catch((e) => setErr(formatErr(e?.response?.data?.detail) || String(e)));
  }, [projectId]);

  const generate = async () => {
    setErr(""); setBlobUrl(null); setBusy(true);
    try {
      const { data } = await api.post(`/projects/${projectId}/ga.svg`,
        { view, discipline, run_id: runId || undefined, drawing_no: drawingNo || undefined, revision },
        { responseType: "blob" });
      const fn = `GA-${view}-${revision}.svg`;
      setFilename(fn);
      setBlobUrl(URL.createObjectURL(data));
    } catch (e) {
      try {
        const txt = await e?.response?.data?.text?.();
        setErr(formatErr(txt && JSON.parse(txt).detail) || String(e));
      } catch { setErr(formatErr(e?.response?.data?.detail) || String(e)); }
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="ga-panel" style={{ display: "grid", gridTemplateColumns: "320px 1fr", gap: 12 }}>
      <div style={card}>
        <div style={label}>General Arrangement View</div>
        <select style={input} data-testid="ga-view"
          value={view} onChange={(e) => setView(e.target.value)}>
          {views.map((v) => <option key={v.id} value={v.id}>{v.label}</option>)}
        </select>
        <div style={{ height: 6 }} />
        <select style={input} data-testid="ga-discipline"
          value={discipline} onChange={(e) => setDiscipline(e.target.value)}>
          {disciplines.map((d) => <option key={d} value={d}>{d}</option>)}
        </select>

        <div style={{ height: 10 }} />
        <div style={label}>Source</div>
        <input style={input} data-testid="ga-run-id" placeholder="Run ID (optional — defaults to latest)"
          value={runId} onChange={(e) => setRunId(e.target.value)} />

        <div style={{ height: 10 }} />
        <div style={label}>Drawing Meta</div>
        <input style={input} data-testid="ga-drawing-no" placeholder="Drawing No (optional)"
          value={drawingNo} onChange={(e) => setDrawingNo(e.target.value)} />
        <div style={{ height: 6 }} />
        <input style={input} data-testid="ga-revision" placeholder="Revision"
          value={revision} onChange={(e) => setRevision(e.target.value)} />

        <div style={{ height: 10 }} />
        <button style={{ ...btn, width: "100%" }} data-testid="ga-generate" onClick={generate} disabled={busy}>
          {busy ? "Generating…" : "Generate GA Drawing"}
        </button>
        {blobUrl && (
          <button style={{ ...btnGhost, width: "100%", marginTop: 6 }}
            data-testid="ga-download" onClick={() => downloadBlob(blobUrl, filename)}>
            Download {filename}
          </button>
        )}
        {err && <div style={{ marginTop: 8, padding: 8, fontSize: 11, color: "#FF8888", background: "rgba(239,68,68,.1)", borderRadius: 4 }}>{err}</div>}

        <div style={{ marginTop: 12, padding: 8, fontSize: 10, color: "var(--pf-muted)", background: "var(--pf-surface-2)", borderRadius: 4 }}>
          Projects 3-D model orthographically — Plan (X-Y, north up), Elevation (X-Z) or Section (Y-Z). A1 landscape with grid, scale-bar, north arrow and title-block.
        </div>
      </div>

      <SvgViewer blobUrl={blobUrl} testId="ga-svg" emptyText="Pick a view and click Generate to render PLAN / ELEVATION / SECTION orthographic drawings." />
    </div>
  );
}
